<template>
  <AppLink
    class="flex items-center justify-center rounded-full px-2 py-1 hover:bg-selected"
    hide_underline
    :class="{ 'bg-selected': is_active }"
    :data-test="item.data_test"
    :title="!mq.isMobile ? $t(item.title) : ''"
    :to="{ name: item.name, params: { project_id: current_project?.id, ...params } }"
    @click="toggleSidebar"
  >
    <div
      v-tooltip="{ value: hide_title ? $t(item.title) : '', showDelay: 150 }"
      :class="routeItemClasses"
    >
      <div class="flex shrink-0 items-center justify-center">
        <AppIcon
          :class="is_active ? 'text-content' : 'text-content-muted'"
          :name="item.icon"
        />
      </div>
      <div
        v-if="!hide_title"
        :class="['text-sm', is_active ? 'font-bold text-content' : 'font-medium text-content-muted']"
      >
        {{ $t(item.title) }}
      </div>
    </div>
  </AppLink>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useMqService } from '@/plugins/mq';

const store = useStore();

const route = useRoute();
const mq = useMqService();

const props = defineProps({
  item: { type: Object, required: true },
  params: { type: Object, default: () => ({}) },
  hide_title: { type: Boolean },
});

const current_project = computed(() => store.getters.current_project);
const is_active = computed(() => route.name.startsWith(props.item.prefix));
const emit = defineEmits(['update:modelValue']);

const toggleSidebar = () => {
  if (mq.isMobile) {
    emit('update:modelValue', false);
  }
};

const routeItemClasses = computed(() => {
  if (!props.hide_title) {
    return 'flex items-center gap-3 p-1 w-full';
  }
  return 'flex items-center justify-center size-8';
});
</script>
